var repeatMatcher = ({
  baseGuesses,
  repeatCount
}) => baseGuesses * repeatCount;
export { repeatMatcher as default };
